import { Injectable } from "@angular/core";

declare const _: any;

@Injectable({
  providedIn: "root",
})
export class Log {
  public static clear(location: string, message: string, ...args) {
    console.clear();
  }

  public static info(location: string, message: string, ...args) {
    console.info(
      "%c%s : %c%s",
      "font-weight: bold;",
      location,
      "font-weight: normal",
      message,
      ...args,
    );
  }

  public static warn(location: string, message: string, ...args) {
    console.warn(
      "%c%s : %c%s",
      "font-weight: bold;",
      location,
      "font-weight: normal",
      message,
      ...args,
    );
  }

  public static debug(location: string, message: string, ...args) {
    console.debug(
      "%c%s : %c%s",
      "font-weight: bold;",
      location,
      "font-weight: normal",
      message,
      ...args,
    );
  }

  public static error(location: string, message: string, ...args) {
    console.error(
      "%c%s : %c%s",
      "font-weight: bold;",
      location,
      "font-weight: normal",
      message,
      ...args,
    );
  }

  public static table(location: string, message: string, ...args) {
    console.group();
    console.log(
      "%c%s : %c%s",
      "font-weight: bold;",
      location,
      "font-weight: normal",
      message,
    );
    _.each(args, (arg) => {
      console.table(arg);
    });
    console.groupEnd();
  }

  public static trace(location: string, message: string) {
    console.group();
    console.log(
      "%c%s : %c%s",
      "font-weight: bold;",
      location,
      "font-weight: normal",
      message,
    );
    // console.trace();
    console.groupEnd();
  }
}
